<div class="container no-padding full-width border-head cboth main-fix-footer-pad">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 no-padding flex-center-div mob-pad-10">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 left-sec no-padding dont-display">
        </div>
        <div
            class="col-xs-12 col-sm-12 col-md-6 col-lg-6 right-sec no-padding card-box-shadow top-bottom-spec-50 mob-top-bottom-spc-40">
            <div class="clearfix no-gutter-sm contentpop-block">
                <div class="center-block">
                    <div class="mobTab">
                        <div class="content-box clearfix">
                            <div class="row">
                                <div class="col-xs-12 text-center success-block top-pad-20">
                                    <p class="mobile-number">Your application is already open in another tab, please
                                        continue existing application</p>
                                    <div class="divider-line top-spc-20 line-margin line-spec"></div>
                                    <hr class="dashed">
                                    <offer-add [addLocation]="'reject'"></offer-add>
                                    <div class="row top-spc-20 bottom-margin-30">
                                        <button id="confirmOtp_next" class="btn btn-block btnconfirm"
                                            (click)="ExploreMore()">
                                            <span>Explore More</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>